import type { FaireReviewEntity } from "../../entity_types/review";

// Real per-product review for Noble Mick's - Craft Beverage Company's
// "Pina Colada Frozen Cocktail -Just add Water + Rum" (p_97744k3y95), pulled
// from Faire's live `GET /api/product-reviews/product/{product_token}`
// endpoint (the same data source that powers the product's own PDP review
// list) — verbatim comment, real reviewer, real rating, real publish date.
export const review_nm2: FaireReviewEntity = {
  token: "review_nm2",
  type: "review",
  brandName: "Noble Mick's - Craft Beverage Company",
  brandToken: "b_kxk5df5zt5",
  productToken: "p_97744k3y95",
  reviewType: "product",
  reviewerName: "Alicia A.",
  reviewerLocation: "Wimberley, TX, United States",
  stars: 5,
  reviewText: "Best seller!",
  reviewDate: "Jun 17, 2026",
  meta: {
    source: "api" as const,
    importedAt: "2026-08-11T21:06:39.000Z",
    importedBy: "entity-db-cli",
  },
};
